export default {
  "pages": {
    "Navbar": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可愛い猫"])},
      "mint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["鋳造"])},
      "lang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN"])}
    },
    "Footer": {
      "love": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分散した世界への愛を込めて作られました"])}
    },
    "Home": {
      "greeting": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可愛い猫"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ゴロゴロと幸運の毎日の投与量を取得します"])},
        "get": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自分の猫を手に入れよう"])}
      },
      "about": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<span>かわいい猫</span> <br> について"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["かわいい猫ほどかわいいものはありません！ 小さなかわいい体と柔らかい足で武装したこれらの猫は、飼い主を負のエネルギーから守り、幸運をもたらします。<br><br> それぞれの猫は他に類を見ないもので、100％あなたが所有しています。 150以上の手描きの特性から生成されたかわいい猫は、イーサリアムブロックチェーンに住んでいて、永遠にあなたに仕えます。"])},
        "connect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ウォレットを接続する"])},
        "minted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["鋳造"])}
      },
      "collection": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["猫コレクション"])},
        "girl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ネコ"])}
      },
      "artist": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アーティストについて"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["南裕子は、東京を拠点に活動するイラストレーター兼コミックアーティストです。 2012年に武蔵野美術大学を卒業。東京イラストレーター協会会員。 ヒロコは猫好きで、ヨッシーとモモの2匹を飼っています。 <br><br> 彼女は、パナソニック、京都アニメーション、ホンダモーター、キヤノン、そして国内外の100以上の企業やスタジオでイラストレーターとして働いてきました。"])},
        "follow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Twitterでフォロー"])}
      },
      "roadmap": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ロードマップ"])},
        "steps": [
          {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ヴィジョン"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["私たちのビジョンは、カワイイ猫を世界的に認知されたブランドに拡大することです。 自由なコミュニケーションと前向きな雰囲気で、国境や国の外に存在する世界を作りたいと思っています。"])}
          },
          {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["コミュニティ"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ミントの収益の20％と永続的な二次収益の25％がコミュニティウォレットに割り当てられます。 グッズの作成、イベントの実行、アニメーションなど、ビジネスへの再投資に使用され、コミュニティの世界を構築し続けます。"])}
          },
          {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["マーチャンダイジング"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ネココレクションから特定の特徴を取り入れ、誰もが楽しめるスタイルを想起させるユニークな商品を作る予定です。 私たちの最初のコレクションは生産の初期段階にあり、6月に発売される予定です。"])}
          },
          {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ロードマップ2.0"])},
            "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NFTスペースは高速で移動し、物事は研ぎ澄まされて前進し続ける必要があることを私たちは知っています。 だからこそ、私たちは空の約束をしたり、誤った期待を抱いたりしたくないのです。 私たちは常に進化するNFTスペースに適応しているため、可能な限り多くの品質価値を提供できます。 私たちは、機会が提示されたときに、以前に行われた約束に縛られて実行できないのではなく、機会を探求できる柔軟性を求めています。"])}
          }
        ]
      },
      "faq": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["よくある質問"])},
        "questions": [
          {
            "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ミントするとき？"])},
            "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5月27日午後8時UTC。"])}
          },
          {
            "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["鋳造価格はいくらですか？"])},
            "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["0.009eth+ガス。 最初の1000は無料です（ウォレットごとに最大2つ無料）。"])}
          },
          {
            "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたの契約はガス効率が良くなるように最適化されていますか？"])},
            "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もちろん、ERC721A契約を使用しています。"])}
          },
          {
            "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["総供給量はいくらですか？"])},
            "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["これまでに生まれたかわいい猫は5555匹だけです。"])}
          },
          {
            "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["カワイイ猫をミントするにはどうすればいいですか？"])},
            "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたは私たちのウェブサイトまたは契約でミントすることができます。"])}
          },
          {
            "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アートワークにはどのような権利がありますか？"])},
            "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたの心が望むようにあなたはあなたのカワイイ猫を自由に使うことができます。 それを購入することにより、あなたはあなたのNFTと含まれているアートワークを商業的またはその他の方法でやりたいことをする完全かつ完全な権利を与えられます。"])}
          }
        ]
      }
    }
  }
}